/* eslint-disable */
/**
 * Ported from https://github.com/paulirish/lite-youtube-embed
 *
 * A lightweight vimeo embed. Still should feel the same to the user, just MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these:
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube (👍👍)
 *   https://github.com/Daugilas/lazyYT
 *   https://github.com/vb/lazyframe
 */

function removeDisplayNone(videoImage) {
  if (videoImage.getAttribute("style") === "display:none;") {
    //Remove the inline style used to hide the object
    videoImage.removeAttribute("style");
  } else {
    console.error("Custom Vimeo screenshot load error: screenshot inline style must be display:none;");
  }
}

if (!customElements.get('lite-vimeo')) {
  class LiteVimeo extends HTMLElement {
    constructor() {
      super();
      // TODO: support dynamically setting the attribute via attributeChangedCallback
    }

    static enableMarketoVimeoTracking(iframeEl, videoId, videoTitle, vimeoParams) {
      if (window.Munchkin && window.Vimeo && iframeEl instanceof HTMLIFrameElement && typeof videoId === 'string' && typeof videoTitle === 'string') {
        // Check that Munckin and Vimeo are available and the expected arguments are of the correct type
        if (!('marketoVimeoTrackingSessionId' in window)) {
          window.marketoVimeoTrackingSessionId = Date.now();
        }
        window.Munchkin.init('314-QPM-328');
        const player = new Vimeo.Player(iframeEl);
        let timePlayed = 0;
        let lastTimestamp = null;
        const timekeeper = performance && typeof performance.now === 'function' ? performance : Date;
        const state = {
          "video95percent": {
            sent: false
          },
          "video75percent": {
            sent: false
          },
          "video50percent": {
            sent: false
          },
          "video25percent": {
            sent: false
          },
          "videostart": {
            sent: false
          }
        };
        let statusCode = 1;

        const getSeconds = (timeString) => {
          let minutes;
          let seconds;
          let temp = ""
          if (typeof timeString !== 'string' || timeString.length < 2) {
              return null;
          }
          for (let i = 0; i < timeString.length; i++) {
              if (timeString[i] === 'm' && temp.length > 0) {
                  minutes = temp;
                  temp = "";
                  continue;
              } else if (timeString[i] === 's' && temp.length > 0) {
                  seconds = temp;
                  temp = "";
                  continue;
              }
              if (timeString[i] >= '0' && timeString[i] <= '9') {
                  temp = temp + timeString[i];
              } else {
                  return null;
              }
          }
          return (parseInt(minutes, 10) * 60 || 0) + (parseInt(seconds, 10) || 0);
        }

        const getDuration = (paramString) =>{
          if (typeof paramString === 'string' && paramString.length > 1 && paramString[0] === "#" && typeof URLSearchParams !== 'undefined') {
              let res = new URLSearchParams(paramString.substring(1));
              const start = res.get("t");
              const end = res.get("end");
              const startSeconds = getSeconds(start);
              const endSeconds = getSeconds(end);
              if (typeof startSeconds === 'number' && typeof endSeconds === 'number' && endSeconds > startSeconds) {
                  return endSeconds - startSeconds;
              } else if (typeof startSeconds === 'number' && end === null) {
                  return startSeconds;
              }
          }
          return null;
        }

        const sendMarketoVideoTrackingEvent = (videoId, videoProgress, videoTitle, videoPlaybackPosition, videoDuration, statusCode) => {
          const domain = location.protocol + '//' + location.host;
          const data = {
            'url': `${location.href.substring(domain.length)}`,
            'params': `session-id=${window.marketoVimeoTrackingSessionId}&url=${encodeURIComponent(location.href)}&video-id=${encodeURIComponent(videoId)}&video-progress=${encodeURIComponent(videoProgress)}&video-title=${encodeURIComponent(videoTitle)}&video-playback-position=${videoPlaybackPosition}&video-duration=${videoDuration}&status-code=${statusCode}&timestamp=${Date.now()}`
            };
          Munchkin.munchkinFunction('visitWebPage', data);
        }

        const reloadListeners = () => {
          // Reattach listeners - helps prevent a bug where player events fail to fire when multiple videos
          // are on a page.
          // Since play can occur even if the video is not paused, ensure that listeners are disabled
          // before adding them again to prevent multiple listeners.
          player.off('seeked');
          player.off('bufferstart');
          player.off('timeupdate');
          player.on('seeked', function(data) {
            // If the user seeks on the video, clear the timer to prevent adding time
            // while the user is seeking (timeupdate fires concurrently with seeked)
            lastTimestamp = null;
          });
          player.on('bufferstart', function(data) {
            // If the user scrolls to an unloaded part of the video, clear the timer
            // so that the loading time of the video doesn't get added
            lastTimestamp = null;
          });
          player.on('timeupdate', function(data) {
              const currentTime = timekeeper.now() / 1000;
              if (lastTimestamp) {
                // Every timeupdate event update the timePlayed if a previous lastTimestamp was set
                // the lastTimestamp is set to a millisecond value in several cases
                // - the video is played
                // - inside timeupdate, after updating timePlayed (in this function, directly below)
                // - inside timeupdate, if lastTimestamp is falsy.
                timePlayed += currentTime - lastTimestamp;
                lastTimestamp = currentTime;
                const progressEvents = [
                  { threshold: 0.95, label: 'video95percent' },
                  { threshold: 0.75, label: 'video75percent' },
                  { threshold: 0.5, label: 'video50percent' },
                  { threshold: 0.25, label: 'video25percent' },
                  { threshold: 0, label: 'videostart' }
                ];
                for (const event of progressEvents) {
                  let duration;
                  if (vimeoParams) {
                    duration = getDuration(vimeoParams) || data.duration;
                  } else {
                    duration = data.duration;
                  }
                  if (timePlayed >= duration * event.threshold && !state[event.label].sent) {
                    sendMarketoVideoTrackingEvent(videoId, event.label, videoTitle, data.seconds, duration, statusCode);
                    state[event.label].sent = true;
                    break;
                  }
                }
              } else {
                // Sometimes when the user seeks on the video, a seeked event fires
                // after the play event fires which results in tracking hanging because
                // the lastTimestamp is set to null and nothing will set it. To
                // workaround this, it's set here only if unset as a backup. This makes the
                // timePlayed calculation inaccurate, but it's better than not tracking
                // any data at all.
                lastTimestamp = timekeeper.now() / 1000;
                statusCode = 2;
              }
          });
        }

        player.on('play', function(data) {
          // Play is outside of reload listeners because it's needed to call reloadListners
          // and also for some reason always seems to fire correctly so the the bugfix isn't
          // needed here.
          lastTimestamp = timekeeper.now() / 1000;
          reloadListeners();
        });
    
        player.on('pause', function(data) {
          // Disable listeners when paused to help improve performance.
          player.off('seeked');
          player.off('bufferstart');
          player.off('timeupdate');
          player.getCurrentTime().then(function(seconds) {
          });
        });
      }
    }

    async connectedCallback() {
      if (!document.getElementById("vimeoPlayerScriptArea")) {
        const script = document.createElement('script')
        script.id = "vimeoPlayerScriptArea";
        script.async = true;
        script.src = "https://player.vimeo.com/api/player.js"
        document.body.appendChild(script);
       }
      // Gotta encode the untrusted value
      // https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#rule-2---attribute-escape-before-inserting-untrusted-data-into-html-common-attributes
      this.videoId = encodeURIComponent(this.getAttribute('videoid'));

      let playBtnEl = this.querySelector('.lty-playbtn');
      // A label for the button takes priority over a [playlabel] attribute on the custom-element
      this.playLabel = (playBtnEl && playBtnEl.textContent.trim()) || this.getAttribute('playlabel') || 'Play';

      // Prepare to fetch oembed json for (only if needed) placeholder image and (in all cases) schema script insertion.
      this.vimeoHref = this.getAttribute('href');
      let oembedData;
      let oembedJson;
      let schemaScript = document.createElement("script");

      // Fetch and parse oembed JSON.
      try {
        oembedData = await fetch(`https://vimeo.com/api/oembed.json?url=${encodeURIComponent(this.vimeoHref)}`);
        oembedJson = await oembedData.json();
        this.videoTitle = oembedJson.title;
      } catch (error) {
        console.error("Vimeo API error");
      }

      // If vimeo image needed, try getting from API response. Otherwise, use general placeholder.
      const videoImage = this.querySelector("img");
      if (videoImage.hasAttribute("data-fetch-vimeo-image")) {
        let {width, height} = LiteVimeo.getThumbnailDimensions(this.getBoundingClientRect());
        const devicePixelRatio = window.devicePixelRatio || 1;
        width *= devicePixelRatio;
        height *= devicePixelRatio;

        try {
          const thumbnailUrl = oembedJson.thumbnail_url.replace(/^(.+_)(.+)$/, `$1${Math.round(width)}x${Math.round(height)}`);
          videoImage.src = thumbnailUrl;
        } catch {
          console.error("Vimeo loader failed: Using placeholder");
          videoImage.src = videoImage.getAttribute('data-fallback-vimeo-image');
        }
        removeDisplayNone(videoImage);
      }

      // Attempt to set video schema using earlier API response.
      try {
        schemaScript.type = 'application/ld+json';
        schemaScript.innerHTML = `{
          "@context": "https://schema.org",
          "@type": "VideoObject",
          "name": "${oembedJson.title.replace(/[^a-z A-Z 0-9 ,\-.?"+]/g, '').replaceAll('"', "&quot;")}",
          "description": "${(oembedJson.description).replace(/[^a-z A-Z 0-9 ,\-.?"+]/g, '').replaceAll('"', "&quot;")}",
          "uploadDate": "${oembedJson.upload_date}",
          "duration": "PT${oembedJson.duration}S",
          "embedUrl": "https://vimeo.com/${oembedJson.video_id}",
          "thumbnailUrl": "${oembedJson.thumbnail_url}"
        }`
        this.appendChild(schemaScript)

      } catch (error) {
      console.error("Vimeo error: could not set schema");
      }

      // Set up play button, and its visually hidden label
      if (!playBtnEl) {
        playBtnEl = document.createElement('button');
        playBtnEl.type = 'button';
        playBtnEl.classList.add('lty-playbtn');
        this.append(playBtnEl);
      }
      if (!playBtnEl.textContent) {
        const playBtnLabelEl = document.createElement('span');
        playBtnLabelEl.className = 'is-visually-hidden';
        playBtnLabelEl.textContent = this.playLabel;
        playBtnEl.append(playBtnLabelEl);
      }
      // playBtnEl.removeAttribute('href');
      // preventDefault instead of removing href for seo reasons
      playBtnEl.addEventListener('click', (e) => e.preventDefault());

      let eventTarget = this;

      if (window.pageHasAutoplayVideo === undefined) {
        window.pageHasAutoplayVideo = document.querySelector('[data-modal-autoplay]') !== null;
      }
      // Check to make sure window.mountedModules is an array
      if (window.pageHasAutoplayVideo && "length" in window.mountedModules && window.mountedModules.constructor === Array) {
        // Find the modal that has this lite-vimeo element as a child or return undefined
        const modalForThisVideo = window.mountedModules.find((module) => {
          const matchingModal = 'modalIsReady' in module && module.modalIsReady && module.element.contains(this);
          return matchingModal;
        });
        // If a modal containing this video was found, then add event listeners to make the video
        // play when the modal is opened
        if (modalForThisVideo) {
          modalForThisVideo.onModalOpen = (currentModal) => {
            if (currentModal.querySelector('[data-modal-autoplay]')) {
              // Play the video, we could warmConnnections here, if desired
              this.addIframe();
            }
          };
        } else {
          // If the modal isn't ready when connectedCallback is called, we listen for an event
          // emitted by the modal once it is ready and have the video play once it's opened.
          // I'd have to mull over whether this is needed or not. It's really only an issue
          // if this script is executed before the modal.js script. I'm unsure exactly the
          // execution order (and there also can be network delays) so it's here for safety.
          document.addEventListener('everlaw-modal-ready', (event) => {
          event.detail.modal.onModalOpen = () => {
              if (event.detail.modal.element.querySelector('[data-modal-autoplay]')) {
                // Play the video, we could warmConnnections here, if desired
                this.addIframe();
              }
            };
          });
        }
      }

      // On hover (or tap), warm up the TCP connections we're (likely) about to use.
      eventTarget.addEventListener('pointerover', LiteVimeo.warmConnections, {once: true});

      // Once the user clicks, add the real iframe and drop our play button
      // TODO: In the future we could be like amp-youtube and silently swap in the iframe during idle time
      //   We'd want to only do this for in-viewport or near-viewport ones: https://github.com/ampproject/amphtml/pull/5003
      eventTarget.addEventListener('click', () => this.addIframe());
    }

    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     */
    static addPrefetch(kind, url, as) {
      const linkElem = document.createElement('link');
      linkElem.rel = kind;
      linkElem.href = url;
      if (as) {
        linkElem.as = as;
      }
      linkElem.crossorigin = true;
      document.head.appendChild(linkElem);
    }

    /**
       * Begin pre-connecting to warm up the iframe load
       * Since the embed's network requests load within its iframe,
       *   preload/prefetch'ing them outside the iframe will only cause double-downloads.
       * So, the best we can do is warm up a few connections to origins that are in the critical path.
       *
       * Maybe `<link rel=preload as=document>` would work, but it's unsupported: http://crbug.com/593267
       * But TBH, I don't think it'll happen soon with Site Isolation and split caches adding serious complexity.
       */
    static warmConnections() {
      if (LiteVimeo.preconnected) return;

      // The iframe document and most of its subresources come right off player.vimeo.com
      LiteVimeo.addPrefetch('preconnect', 'https://player.vimeo.com');
      // Images
      LiteVimeo.addPrefetch('preconnect', 'https://i.vimeocdn.com');
      // Files .js, .css
      LiteVimeo.addPrefetch('preconnect', 'https://f.vimeocdn.com');
      // Metrics
      LiteVimeo.addPrefetch('preconnect', 'https://fresnel.vimeocdn.com');

      LiteVimeo.preconnected = true;
    }

    async addIframe() {
      if (this.classList.contains('is-activated')) return;
      this.classList.add('is-activated');

      const paramsAttributeValue = this.getAttribute('params');

      let params = '?autoplay=1&playsinline=1' + (paramsAttributeValue || '');

      const iframeEl = document.createElement('iframe');
      iframeEl.width = 640;
      iframeEl.height = 360;
      iframeEl.frameborder = 0;
      // No encoding necessary as [title] is safe. https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#:~:text=Safe%20HTML%20Attributes%20include
      iframeEl.title = this.playLabel;
      iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframeEl.allowFullscreen = true;
      // AFAIK, the encoding here isn't necessary for XSS, but we'll do it only because this is a URL
      // https://stackoverflow.com/q/64959723/89484
      iframeEl.src = `https://player.vimeo.com/video/${encodeURIComponent(this.videoId)}${decodeURIComponent(params)}`;
      this.append(iframeEl);
      // Set focus for a11y
      iframeEl.focus();
      try {
        LiteVimeo.enableMarketoVimeoTracking(iframeEl, this.videoId, this.videoTitle, paramsAttributeValue);
      } catch (e) {
        console.error("Marketo tracking error");
      }
    }

    /**
     * Get the thumbnail dimensions to use for a given player size.
     *
     * @param {Object} options
     * @param {number} options.width The width of the player
     * @param {number} options.height The height of the player
     * @return {Object} The width and height
     */
    static getThumbnailDimensions({width, height}) {
      let roundedWidth = width;
      let roundedHeight = height;

      // If the original width is a multiple of 320 then we should
      // not round up. This is to keep the native image dimensions
      // so that they match up with the actual frames from the video.
      //
      // For example 640x360, 960x540, 1280x720, 1920x1080
      //
      // Round up to nearest 100 px to improve cacheability at the
      // CDN. For example, any width between 601 pixels and 699
      // pixels will render the thumbnail at 700 pixels width.
      if (roundedWidth % 320 !== 0) {
        roundedWidth = Math.ceil(width / 100) * 100;
        roundedHeight = Math.round((roundedWidth / width) * height);
      }


      return {
        width: roundedWidth,
        height: roundedHeight,
      };
    }
  }
  // Register custom element
  customElements.define('lite-vimeo', LiteVimeo);
}
